import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/checkout-links/create")({
  component: () => (
    <MaskRedirect
      to="/admin/checkout-links"
      action="create"
      mask="/admin/checkout-links/create"
    />
  ),
});
